var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "p-10" },
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("PaymentTransferDetails.viewHeader")))]),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 5 } },
        [
          _c(
            "el-col",
            { attrs: { span: 30 } },
            [
              _c(
                "el-card",
                [
                  _c(
                    "el-checkbox",
                    {
                      on: { change: _vm.onChangeShowUnmatchedLines },
                      model: {
                        value: _vm.show_unmatched_lines,
                        callback: function($$v) {
                          _vm.show_unmatched_lines = $$v
                        },
                        expression: "show_unmatched_lines"
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("PaymentTransferDetails.showUnmatchedLines")
                        )
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tabs",
                    {
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t(
                              "PaymentTransferDetails.statementsListHeader"
                            ),
                            name: "statementsTab"
                          }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              on: { change: _vm.onChangeHideSimpleMatches },
                              model: {
                                value: _vm.hide_simple_matches,
                                callback: function($$v) {
                                  _vm.hide_simple_matches = $$v
                                },
                                expression: "hide_simple_matches"
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "PaymentTransferDetails.hideSimpeMatches"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.statementLines,
                                disabled: _vm.loading
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.transactionReference"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "transaction_reference",
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.transactionDate"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "transaction_date",
                                  formatter: _vm.formatDate,
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.statementStructuredMessage"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "structured_message",
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.statementAmount"
                                  ),
                                  "show-overflow-tooltip": "",
                                  width: "192"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              scope.row.transaction_credit_amount.toLocaleString(
                                                "nl-BE",
                                                {
                                                  style: "currency",
                                                  currency: "EUR"
                                                }
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.statementMatchStatus"
                                  ),
                                  "show-overflow-tooltip": "",
                                  width: "192"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.translateMatchStatusDescription(
                                                scope.row
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.statementMatchType"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "selected_match_type",
                                  width: "192"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.translateMatchTypeDescription(
                                                scope.row.selected_match_type
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: { type: "expand" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c(
                                          "el-table",
                                          {
                                            ref: "multipleTableMapping",
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              data: scope.row.matches,
                                              disabled: _vm.loading,
                                              "show-header": false
                                            }
                                          },
                                          [
                                            _c("el-table-column", {
                                              attrs: { width: "50" }
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: { width: "50" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope2) {
                                                      return [
                                                        _c("el-checkbox", {
                                                          attrs: {
                                                            disabled:
                                                              _vm.readonly
                                                          },
                                                          model: {
                                                            value:
                                                              scope2.row
                                                                .selected,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                scope2.row,
                                                                "selected",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "scope2.row.selected"
                                                          }
                                                        })
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                label: _vm.$t(
                                                  "PaymentTransferDetails.statementMatchType"
                                                ),
                                                "show-overflow-tooltip": "",
                                                width: "192"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope7) {
                                                      return [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.translateMatchTypeDescription(
                                                                scope7.row
                                                                  .match_type
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: { width: "192" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope6) {
                                                      return [
                                                        scope6.row.match_type ==
                                                        "INVOICE"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "hover-underline blueColor",
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "recipient",
                                                                    params: {
                                                                      reference:
                                                                        scope6
                                                                          .row
                                                                          .match_reference
                                                                    }
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return $event.stopImmediatePropagation()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      scope6.row
                                                                        .match_description
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        scope6.row.match_type ==
                                                        "DUNNING_NOTICE"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "hover-underline blueColor",
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "invoice-detail",
                                                                    params: {
                                                                      id:
                                                                        scope6
                                                                          .row
                                                                          .match_parent_reference
                                                                    }
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return $event.stopImmediatePropagation()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      scope6.row
                                                                        .match_description
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        scope6.row.match_type ==
                                                        "PAYMENT_PROMISE"
                                                          ? _c(
                                                              "router-link",
                                                              {
                                                                staticClass:
                                                                  "hover-underline blueColor",
                                                                attrs: {
                                                                  to: {
                                                                    name:
                                                                      "edit-payment-plan",
                                                                    params: {
                                                                      id:
                                                                        scope6
                                                                          .row
                                                                          .match_parent_reference
                                                                    }
                                                                  }
                                                                },
                                                                nativeOn: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    return $event.stopImmediatePropagation()
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      scope6.row
                                                                        .match_description
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e()
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                prop: "match_amount",
                                                width: "192"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope3) {
                                                      return [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              scope3.row.match_document_total_amount.toLocaleString(
                                                                "nl-BE",
                                                                {
                                                                  style:
                                                                    "currency",
                                                                  currency:
                                                                    "EUR"
                                                                }
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                prop: "match_type",
                                                width: "192"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function(scope4) {
                                                      return [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              _vm.translateMatchTypeDescription(
                                                                scope4.row
                                                              )
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c("el-table-column", {
                                              attrs: {
                                                "show-overflow-tooltip": "",
                                                prop: "match_payment_reference",
                                                width: "192"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("label", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "PaymentTransferDetails.PaymentTranfers"
                                              )
                                            ) + " "
                                          )
                                        ]),
                                        _vm._v(" "),
                                        !_vm.paymentTransferLines.some(
                                          x =>
                                            x.transaction_reference ===
                                            scope.row.transaction_reference
                                        )
                                          ? _c("label", [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\t\t" +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "PaymentTransferDetails.DuplicateStatementMessage"
                                                    )
                                                  ) +
                                                  "\n\t\t\t\t\t\t\t\t\t"
                                              )
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.paymentTransferLines !== undefined
                                          ? _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-table",
                                                  {
                                                    ref: "multipleTable",
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      data: _vm.paymentTransferLines.filter(
                                                        x =>
                                                          x.transaction_reference ===
                                                          scope.row
                                                            .transaction_reference
                                                      ),
                                                      disabled: _vm.loading,
                                                      height: "100",
                                                      "show-header": false
                                                    }
                                                  },
                                                  [
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        type: "index",
                                                        width: "10"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "PaymentTransferDetails.transactionReference"
                                                        ),
                                                        "show-overflow-tooltip":
                                                          "",
                                                        prop:
                                                          "transaction_reference",
                                                        width: "192"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "PaymentTransferDetails.paymentTranferAmount"
                                                        ),
                                                        "show-overflow-tooltip":
                                                          "",
                                                        width: "192"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              scope5
                                                            ) {
                                                              return [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      scope5.row
                                                                        .amount !==
                                                                        null
                                                                        ? scope5.row.amount.toLocaleString(
                                                                            "nl-BE",
                                                                            {
                                                                              style:
                                                                                "currency",
                                                                              currency:
                                                                                "EUR"
                                                                            }
                                                                          )
                                                                        : ""
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "PaymentTransferDetails.statementMatchType"
                                                        ),
                                                        "show-overflow-tooltip":
                                                          "",
                                                        prop: "type",
                                                        width: "192"
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function(
                                                              scope6
                                                            ) {
                                                              return [
                                                                _vm._v(
                                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                                    _vm._s(
                                                                      _vm.translatePaymentTransferLineType(
                                                                        scope6
                                                                          .row
                                                                          .type
                                                                      )
                                                                    ) +
                                                                    "\n\t\t\t\t\t\t\t\t\t\t\t\t"
                                                                )
                                                              ]
                                                            }
                                                          }
                                                        ],
                                                        null,
                                                        true
                                                      )
                                                    }),
                                                    _vm._v(" "),
                                                    _c("el-table-column", {
                                                      attrs: {
                                                        label: _vm.$t(
                                                          "PaymentTransferDetails.paymentTransferPaymentReference"
                                                        ),
                                                        "show-overflow-tooltip":
                                                          "",
                                                        prop:
                                                          "payment_reference",
                                                        width: "450"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("paymentTransferListHeader"),
                            name: "transferTab"
                          }
                        },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.loading,
                                  expression: "loading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.paymentTransferLines,
                                disabled: _vm.loading
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.transactionReference"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "transaction_reference",
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.paymentTranferAmount"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "amount",
                                  width: "192"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              scope.row.amount.toLocaleString(
                                                "nl-BE",
                                                {
                                                  style: "currency",
                                                  currency: "EUR"
                                                }
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.statementMatchType"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "type",
                                  width: "192"
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.translatePaymentTransferLineType(
                                                scope.row.type
                                              )
                                            ) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.paymentTransferPaymentReference"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "payment_reference",
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.recipientBankAccountNumber"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "target_bank_account_number",
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.sourceBankAccountNumber"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "source_bank_account_number",
                                  width: "192"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "PaymentTransferDetails.targetBankAccountNumber"
                                  ),
                                  "show-overflow-tooltip": "",
                                  prop: "target_bank_account_number",
                                  width: "192"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }